interface IGetAllClientBookmarkByClientRequest {
}
class GetAllClientBookmarkByClientRequest implements IGetAllClientBookmarkByClientRequest {
}

export {
    GetAllClientBookmarkByClientRequest
}


// WEBPACK FOOTER //
// ./src/presentation/request/client_bookmark_request.ts